import { Component, OnInit } from '@angular/core';
import { Constants } from "../../core/helpers/constants";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  standalone:true,
  imports:[]
})

/**
 * Footer component
 */
export class FooterComponent implements OnInit {

  // set the current year
  year: number = new Date().getFullYear();
  name: string;
  author: string;

  constructor() {
    this.year = new Date().getFullYear();
    this.name = Constants.getProjectName();
    this.author = Constants.getAuthor();
  }

  ngOnInit() {
  }

}
